import {isResearchField} from '../../../shared/enrichment';
import {useCustomer} from '../../../hooks/api/metadata';
import {isAiFieldDefinition} from '../../../shared/enrichment';
import {ObjectId} from 'bson';

export function useAgentResearcherField(agentId: ObjectId) {
  const fieldDefinitions = useCustomer().fieldDefinitions ?? [];
  return fieldDefinitions
    .filter(isResearchField)
    .find((fieldDefinition) => fieldDefinition.agentId?.equals(agentId));
}

export function useAgentAnalystField(agentId: ObjectId) {
  const fieldDefinitions = useCustomer().fieldDefinitions ?? [];
  return fieldDefinitions
    .filter(isAiFieldDefinition)
    .filter((fieldDefinition) => !isResearchField(fieldDefinition))
    .find((fieldDefinition) => fieldDefinition.agentId?.equals(agentId));
}

export function useAgentFields(agentId: ObjectId) {
  const agentResearcherField = useAgentResearcherField(agentId);
  const agentAnalystField = useAgentAnalystField(agentId);
  return {
    researcherField: agentResearcherField,
    analystField: agentAnalystField,
  };
}
